import React from "react";
import {InputAdornment, TextField, SvgIcon, Icon} from "@mui/material";
import { useController, useForm } from "react-hook-form";
import TwitchIcon  from "@/pages/TwitchIcon";
import { Instagram, YouTube, Twitter, Facebook, Paid, Web } from "@mui/icons-material";

const ICON_MAP = {
    instagram: Instagram,
    youtube: YouTube,
    facebook: Facebook,
    twitter: Twitter,
    twitch: TwitchIcon,
    phone: Paid,
    iframe: Web,
    image: Web,
}

export default function Input({ register, name, label }) {
    const { onChange, onBlur, ref } = register(name);
    const Icon = ICON_MAP[name];

    return (
        <>
            <TextField
                onChange={onChange} // send value to hook form
                onBlur={onBlur} // notify when input is touched/blur
                name={name} // send down the input name
                inputRef={ref} // send input ref, so we can focus on input when error appear
                label={label}
                type={name === 'image' ? 'file' : 'text'}
                inputProps={{accept: name === 'image' ? 'image/*' : undefined}}
                fullWidth
                required={false}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Icon/>
                        </InputAdornment>
                    ),
                }}
            />
        </>
    );
}
